import React from 'react';
import './styles.scss';
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import { fetchIndividualCompany } from "../../../../../Redux/Slices/companyManagementSlice";



function CompanyInfo() {
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [companyData, setCompanyData] = useState({}) 

    useEffect(()=>{
        dispatch(
            fetchIndividualCompany({
                data:{id},
                callBack: getCompanyCB,
            })
        )
    },[])
    const getCompanyCB = (value)=>{
        // console.log(value);
        setCompanyData(value?.result[0])
    }

    return (
        <div className="companyInfoContainer">
            <div className="companyInfoCard">
                <h3>Company Information</h3>
                <div className="companyDetails">
                    <div className="companyDetailsLeft">
                        <p><span>Company Name</span> : {companyData?.company_name || "-"}</p>
                        <p><span>Company Type</span> : {companyData?.company_type_name || "-"}</p>
                        <p><span>Industry</span> : {companyData?.industry_name || "-"}</p>
                    </div>
                    <div className="companyDetailsRight">
                        <p><span>Date Joined with KG</span> : {new Date(companyData?.createdAt).toLocaleDateString('en-GB') || "-"}</p>
                        {/* <p><span>Date Join on the App</span> : {new Date(companyData?.createdAt).toLocaleDateString('en-GB') || "-"}</p> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompanyInfo;
